import img1  from './images/image1.jpg'
import img2  from './images/image2.jpg'
import img3  from './images/image3.jpg'
import img4  from './images/image4.jpg'
import img5  from './images/image5.jpg'
import img6  from './images/image6.jpg'
import img7  from './images/image7.jpg'
import img8  from './images/image8.jpg'
import img9  from './images/image9.jpg'
import img10 from './images/image10.jpg'
import img11 from './images/image11.jpg'
import img12 from './images/image12.jpg'
import img13 from './images/image13.jpg'
import img14 from './images/image14.jpg'
import img15 from './images/image15.jpg'
import img16 from './images/image16.jpg'
import img17 from './images/image17.jpg'
import img18 from './images/image18.jpg'
import img19 from './images/image19.jpg'
import img20 from './images/image20.jpg'
import img21 from './images/image21.jpg'
import img22 from './images/image22.gif'
import img23 from './images/image23.jpg'
import img25 from './images/image25.jpg'
import img26 from './images/image26.jpg'
import img27 from './images/image27.jpg'
import img29 from './images/image29.jpg'
import img30 from './images/image30.jpg'
import img31 from './images/image32.jpg'
import img33 from './images/image33.jpg'
import img34 from './images/image34.jpg'
import img35 from './images/image35.jpg'

import imgTum1  from './images/image1tum.jpg'
 import imgTum2  from './images/image2tum.jpg'
 import imgTum3  from './images/image3tum.jpg'
 import imgTum4  from './images/image4tum.jpg'
 import imgTum5  from './images/image5tum.jpg'
 import imgTum6  from './images/image6tum.jpg'
 import imgTum7  from './images/image7tum.jpg'
 import imgTum8  from './images/image8tum.jpg'
 import imgTum9  from './images/image9tum.jpg'
 import imgTum10 from './images/image10tum.jpg'
 import imgTum11 from './images/image11tum.jpg'
 import imgTum12 from './images/image12tum.jpg'
 import imgTum13 from './images/image13tum.jpg'
 import imgTum14 from './images/image14tum.jpg'
 import imgTum15 from './images/image15tum.jpg'
 import imgTum16 from './images/image16tum.jpg'
 import imgTum17 from './images/image17tum.jpg'
 import imgTum18 from './images/image18tum.jpg'
 import imgTum19 from './images/image19tum.jpg'
 import imgTum20 from './images/image20tum.jpg'
 import imgTum21 from './images/image21tum.jpg'
 import imgTum22 from './images/image22tum.jpg'
 import imgTum23 from './images/image23tum.jpg'
 import imgTum25 from './images/image25tum.jpg'
 import imgTum26 from './images/image26tum.jpg'
 import imgTum27 from './images/image27tum.jpg'
 import imgTum29 from './images/image29tum.jpg'
 import imgTum30 from './images/image30tum.jpg'
 import imgTum31 from './images/image32tum.jpg'
 import imgTum33 from './images/image33tum.jpg'
 import imgTum34 from './images/image34tum.jpg'
 import imgTum35 from './images/image35tum.jpg'


const images = 
  [
    {
      src: img1,
      title: 'The Red Moon',
      description: '2014 - 120x90cm - Oil on Canvas',
      thumbnail : imgTum1
    },
    {
      src: img2,
      title: 'Eldritch moon ',
      description: '2014 - 120x90cm - Oil on Canvas',
      thumbnail : imgTum2
    },
    {
      src: img3,
      title: 'Apperant moon',
      description: '2014 - 120x90cm - Oil on Canvas',
      thumbnail : imgTum3
    },
    {
      src: img4,
      title: 'Furtif moon',
      description: '2014 - 120x90cm - Oil on Canvas',
      thumbnail : imgTum4
    },
    {
      src: img5,
      title: 'May we enter Elysium',
      description: '2020 - 109x114cm - Oil on Canvas',
      thumbnail : imgTum5
    },
    {
      src: img6,
      title: 'Domina Lupus',
      description: '2018 - 90x64cm - Oil on Canvas',
      thumbnail : imgTum6
    },
    {
      src: img7,
      title: 'Domina corvus',
      description: '2018 - 90x64cm - Oil on Canvas',
      thumbnail : imgTum7
    },
    {
      src: img8,
      title: 'Relator',
      description: '2018 - 100x100cm - Oil on Canvas',
      thumbnail : imgTum8
    },
    {
      src: img9,
      title: 'Visitors',
      description: '2018 - 90x110cm - Oil on Canvas',
      thumbnail : imgTum9
    },
    {
      src: img10,
      title: 'The room',
      description: '2018 - 55x85cm - Oil on Canvas',
      thumbnail : imgTum10
    },
    {
      src: img11,
      title: 'Tengu´s watch',
      description: '2019 - 55x85cm - Oil on Canvas',
      thumbnail : imgTum11
    },
    {
      src: img12,
      title: 'Wisdom',
      description: '2019 - 55x85cm - Oil on Canvas',
      thumbnail : imgTum12
    },
    {
      src: img13,
      title: 'At Ali´s',
      description: '2019 - 55x85cm - Oil on Canvas',
      thumbnail : imgTum13
    },
    {
      src: img14,
      title: 'At night, at the woods',
      description: '2017 - 55x85cm - Oil on Canva',
      thumbnail : imgTum14
    },
    {
      src: img15,
      title: 'Untitled',
      description: '2017 - 58x42cm - Oil on Canvas',
      thumbnail : imgTum15
    },
    {
      src: img16,
      title: 'Untitled',
      description: '2012 - 60x90cm - Oil on Canvas',
      thumbnail : imgTum16
    },
    {
      src: img17,
      title: 'Untitled',
      description: '2014 - 55x45cm - Oil on Canvas',
      thumbnail : imgTum17
    },
    {
      src: img18,
      title: 'Untitled',
      description: '2014 - 55x45cm - Oil on Canvas',
      thumbnail : imgTum18
    },
    {
      src: img19,
      title: 'Untitled',
      description: '2014 - 55x45cm - Oil on Canvas',
      thumbnail : imgTum19
    },
    {
      src: img20,
      title: 'Untitled',
      description: '2019 - 55x55cm - Oil on Canvas',
      thumbnail : imgTum20
    },
    {
      src: img21,
      title: 'Untitled',
      description: '2019 - 55x55cm - Oil on Canvas',
      thumbnail : imgTum21
    },
    {
      src: img22,
      title: 'Untitled',
      description: '2019 - 55x55cm - Oil on Canvas',
      thumbnail : imgTum22
    },
    {
      src: img23,
      title: 'Untitled',
      description: '2014 - 55x45cm - Oil on Canvas',
      thumbnail : imgTum23
    },
  
    {
      src: img25,
      title: 'Untitled',
      description: '2014 - 55x45cm - Oil on Canvas',
      thumbnail : imgTum25
    },
    {
      src: img26,
      title: 'Untitled',
      description: '2014 - 55x45cm - Oil on Canvas',
      thumbnail : imgTum26
    },
    {
      src: img27,
      title: 'Untitled',
      description: '2014 - 55x45cm - Oil on Canvas',
      thumbnail : imgTum27
    },
    
    {
      src: img29,
      title: 'Kasba Rocker',
      description: '2016 - 80x60cm - Oil on Canvas',
      thumbnail : imgTum29
    },
    {
      src: img30,
      title: 'Hadj Wifi ',
      description: '2017 - 55x55cm - Oil on Canvas',
      thumbnail : imgTum30
    },
    {
      src: img31,
      title: 'Maghreb',
      description: '2011 - 165x120cm - Oil on Canvas',
      thumbnail : imgTum31
    },
  
    {
      src: img33,
      title: 'Untitled',
      description: '2020 - 55x65cm - Oil on Canvas',
      thumbnail : imgTum33
    },
    {
      src: img34,
      title: 'Untitled',
      description: '2016 - 55x60cm - Oil on Canvas',
      thumbnail : imgTum34
    },
    {
      src: img35,
      title: 'Untitled',
      description: '2016 - 55x60cm - Oil on Canvas',
      thumbnail : imgTum35
    },
   
    
    
  ]



export default images;
